<template>
    <main class="inventory-page__content">
        <VInventoryHeader></VInventoryHeader>

        <VContentHeaderDefault
            title="Справочники форм"
            :button="$_canManageInventory ? 'Создать справочник' : ''"
            @search="onSearch"
            @button="onCreateButtonClick"
        ></VContentHeaderDefault>

        <template v-if="isLoading">
            <div class="inventory-page__loader">
                <VSpinner></VSpinner>
            </div>
        </template>

        <template v-else>
            <VContentTableDefault
                :rows="rows"
                :page="page"
                :total="total"
                :options="options"
                @page="onPageChange"
                @edit="onAttributeClick"
                @click="onAttributeClick"
            ></VContentTableDefault>
            <p class="inventory-page__empty" v-if="!rows.length">Справочников не найдено.</p>
        </template>

        <VInventoryAttributeCreateModal></VInventoryAttributeCreateModal>
    </main>
</template>
<script>
// Components
import VSpinner from '../../components/VProgress/VSpinner.vue';
import PagePaginate from '../../components/PagePaginate/PagePaginate.vue';
import VContentTableDefault from '../../components/VContentTableDefault.vue';
import VContentHeaderDefault from '../../components/VContentHeaderDefault.vue';
import VInventoryHeader from './components/VInventoryHeader.vue';
import VInventoryAttributeCreateModal from './modals/VInventoryAttributeCreateModal.vue';
import './InventoryPage.scss';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { errorMessage } from '../../../js/error';
import { getInventoryAttributeTypes } from '../../../js/inventory-api';
import { withoutHiddenDictionaries } from '../../../js/inventoryAttributes';
import { Watch } from 'vue-property-decorator';
import ModalNames from '../../../js/enums/ModalNames';

@Component({
    components: {
        VSpinner,
        PagePaginate,
        VContentTableDefault,
        VContentHeaderDefault,
        VInventoryHeader,
        VInventoryAttributeCreateModal,
    },
})
class InventoryPageAttributes extends Vue {
    rows = [];
    page = 1;
    total = 1;
    isLoading = true;
    searchString = '';

    /**
     * Вычисляемое, а не поле класса — как у держателей: право правки приходит миксином
     * из хранилища позже полей класса. С editable: true наблюдатель видел «карандаш»,
     * который ничего не делал.
     */
    get options() {
        return {
            editable: this.$_canManageInventory,
            deletable: false,
            columns: [
                {
                    size: 30,
                    label: 'Название',
                    display: (x) => x.type,
                },
                {
                    size: 70,
                    label: 'Значения',
                    display: (x) => x.values,
                },
            ],
        };
    }

    onSearch(searchString) {
        this.page = 1;
        this.searchString = searchString;
    }

    onPageChange(page) {
        this.page = page;
    }

    onAttributeClick(attribute) {
        // Без права правки строка не открывается: здесь нет режима просмотра,
        // и форма всё равно упала бы 403 при сохранении. Для наблюдателя страница
        // остаётся списком.
        if (!this.$_canManageInventory) {
            return;
        }

        this.$router.push({
            name: 'inventory.attributes.type',
            params: {
                type: attribute.type,
            },
            query: {
                prev: this.$route.fullPath,
                type: attribute.type,
                value_type: attribute.value_type,
                searchable: attribute.searchable,
            },
        });
    }

    async onCreateButtonClick() {
        try {
            const attribute = await this.$showModal(ModalNames.INVENTORY_ATTRIBUTE_CREATE_CARD);

            this.$router.push({
                name: 'inventory.attributes.type',
                params: {
                    type: attribute.type,
                },
                query: {
                    prev: this.$route.fullPath,
                    type: attribute.type,
                    value_type: attribute.value_type,
                    searchable: attribute.searchable,
                },
            });
        } catch (error) {
            // The modal was closed.
            return;
        }
    }

    @Watch('page')
    @Watch('searchString')
    async fetchInventoryAttributes() {
        this.isLoading = true;

        try {
            const response = await getInventoryAttributeTypes({
                withValues: true,
            });

            // ГОРОД И СЕРИЙНЫЙ НОМЕР СЮДА НЕ ПОПАДАЮТ (7-D3). Оба перестали быть
            // справочниками: город живёт колонкой inventory_items.city_id, серийный
            // номер — значением конкретной единицы. Строки в базе остаются и читаются
            // по-прежнему, но заводить и пополнять их отсюда больше нечего —
            // см. js/inventoryAttributes.js.
            //
            // Фильтр на клиенте, а не на сервере: тот же /attributes/types отвечает
            // форме создания, которой название справочника серийных номеров как раз
            // нужно — оно определяет, куда лечь введённому номеру.
            this.rows = withoutHiddenDictionaries(response.data.data);
            this.total = this.rows.length;
        } catch (error) {
            const message = errorMessage(error);

            this.$showModal(ModalNames.ERROR, { errorMessage: message });
        } finally {
            this.isLoading = false;
        }
    }

    created() {
        this.fetchInventoryAttributes();
    }
}

export default InventoryPageAttributes;
</script>
<style lang="scss"></style>
